export default "{\n    \"label\": \"Catégories de service\",\n    \"placeholderText\": \"Sélectionner les catégories\"\n}\n"